// API用URL
const GET_POSTALCODES_URL = process.env.VUE_APP_API + 'postal-codes/get?yubin='
const GET_SERVICE_URL = process.env.VUE_APP_API + 'sgm-pickup-services/get?'
const GET_FEE_URL = process.env.VUE_APP_API + 'price-ap/calculation'
const CONF_APP_URL = process.env.VUE_APP_API + 'application/regist'
const GET_MAKER_SIZE_URL = process.env.VUE_APP_API + 'maker-size/get?'
const GET_SETTINGS_URL = process.env.VUE_APP_API + 'settings/get?site_code=' + process.env.VUE_APP_SITE_CODE
const GET_CODE_URL = process.env.VUE_APP_API + 'code/get?'
const CREATE_CONTRACT_URL = process.env.VUE_APP_API + 'contractContent/create'
const DOWNLOAD_CONTRACT_URL = process.env.VUE_APP_API + 'contract/download'
const GET_APP_INFO_URL = process.env.VUE_APP_API + 'applyInfo/get?'

//'0':可, '1':不可
const CYUKEIRYO_KBN = '1'
//'0':可, '1':不可
const LARGEDELIVERY_KB = '1'
//'1':不可
const VALID_FLG = '1'
//メルマガ受信選択表示有無 '1':表示する
const MAIL_OSR_SELECTIVE_DISPLAY = '1'

const CODE_TV = '1'
const CODE_FRIDGE = '2'
const CODE_WASHER_DRYER = '3'
const CODE_AC = '4'
const CODE_MICROWAVE = '5'
const CODE_VACUUM = '6'
const CODE_AP = '7'
const CODE_PRINTER = '8'
const CODE_PC = '9'
const CODE_CRT = '10'
const CODE_SMALL = '11'
const CODE_MEDIUM_OTHER = '13'
const CODE_DESKTOP_MOUSE = '14'
const CODE_NOTE_MOUSE = '15'
const CODE_DISPLAY_MOUSE = '16'
const CODE_CRT_MOUSE = '17'
const CODE_LITHIUM_GAMING_MOUSE = '18'

const NAME_TV = 'テレビ'
const NAME_FRIDGE = '冷蔵庫'
const NAME_WASHER_DRYER = '洗濯機'
const NAME_AC = 'エアコン'
const NAME_MICROWAVE = '電子レンジ'
const NAME_VACUUM = '掃除機'
const NAME_AP = '空気清浄機'
const NAME_PRINTER = 'プリンタ'
const NAME_PC = 'パソコン'
const NAME_CRT = 'CRT(ブラウン管)、モニター'
const NAME_DESKTOP_MOUSE = 'デスクトップパソコン'
const NAME_NOTE_MOUSE = 'ノートパソコン'
const NAME_DISPLAY_MOUSE = 'ディスプレイ'
const NAME_CRT_MOUSE = 'CRTモニター'
const NAME_MEDIUM_OTHER = '（他中型）'
const NAME_SMALL = '小型家電'
const NAME_LITHIUM_GAMING_MOUSE= 'リチウム内蔵ゲーミングマウス'

const ID_TV = 'tv'
const ID_FRIDGE = 'freezer'
const ID_WASHER_DRYER = 'washing'
const ID_AC = 'aircon'
const ID_MICROWAVE = 'microwave'
const ID_VACUUM = 'vacuum_cleaner'
const ID_AP = 'air_cleaner'
const ID_PRINTER = 'printer'
const ID_PC = 'computer'
const ID_CRT = 'monitor'
const ID_DESKTOP_MOUSE = 'desktop_mouse'
const ID_NOTE_MOUSE = 'note_mouse'
const ID_DISPLAY_MOUSE = 'display_mouse'
const ID_CRT_MOUSE = 'crt_mouse'
const ID_LITHIUM_GAMING_MOUSE = 'lithium_gaming_mouse'

const IMAGE_TV = 'resources/sp/images/step2/big_img_tv.png'
const IMAGE_FRIDGE = 'resources/sp/images/step2/big_img_freezer.png'
const IMAGE_WASHER_DRYER = 'resources/sp/images/step2/big_img_washing.png'
const IMAGE_AC = 'resources/sp/images/step2/big_img_aircon.png'
const IMAGE_MICROWAVE = 'resources/sp/images/step3/middle_img_microwave.png'
const IMAGE_VACUUM = 'resources/sp/images/step3/middle_img_vacuum_cleaner.png'
const IMAGE_AP = 'resources/sp/images/step3/middle_img_air_cleaner.png'
const IMAGE_PRINTER = 'resources/sp/images/step3/middle_img_printer.png'
const IMAGE_PC = 'resources/sp/images/step3/middle_img_computer.png'
const IMAGE_CRT = 'resources/sp/images/step3/middle_img_monitor.png'
const IMAGE_DESKTOP_MOUSE = 'resources/sp/images/step3/middle_img_desktop_mouse.png'
const IMAGE_NOTE_MOUSE = 'resources/sp/images/step3/middle_img_note_mouse.png'
const IMAGE_DISPLAY_MOUSE = 'resources/sp/images/step3/middle_img_display_mouse.png'
const IMAGE_CRT_MOUSE = 'resources/sp/images/step3/middle_img_crt_mouse.png'
const IMAGE_LITHIUM_GAMING_MOUSE = 'resources/sp/images/step3/middle_img_lithium_mouse_sp.png'
const IMAGE_SMALL = 'resources/sp/images/step4/small_img.png'
const IMAGE_CAR = 'resources/sp/images/thanks/car_img.png'
const IMAGE_TV_PC = 'resources/pc/images/step2/big_img_tv.png'
const IMAGE_FRIDGE_PC = 'resources/pc/images/step2/big_img_freezer.png'
const IMAGE_WASHER_DRYER_PC = 'resources/pc/images/step2/big_img_washing.png'
const IMAGE_AC_PC = 'resources/pc/images/step2/big_img_aircon.png'
const IMAGE_MICROWAVE_PC = 'resources/pc/images/step3/middle_img_microwave.png'
const IMAGE_VACUUM_PC = 'resources/pc/images/step3/middle_img_vacuum_cleaner.png'
const IMAGE_AP_PC = 'resources/pc/images/step3/middle_img_air_cleaner.png'
const IMAGE_PRINTER_PC = 'resources/pc/images/step3/middle_img_printer.png'
const IMAGE_PC_PC = 'resources/pc/images/step3/middle_img_computer.png'
const IMAGE_CRT_PC = 'resources/pc/images/step3/middle_img_monitor.png'
const IMAGE_DESKTOP_MOUSE_PC = 'resources/pc/images/step3/middle_img_desktop_mouse.png'
const IMAGE_NOTE_MOUSE_PC = 'resources/pc/images/step3/middle_img_note_mouse.png'
const IMAGE_DISPLAY_MOUSE_PC = 'resources/pc/images/step3/middle_img_display_mouse.png'
const IMAGE_CRT_MOUSE_PC = 'resources/pc/images/step3/middle_img_crt_mouse.png'
const IMAGE_LITHIUM_GAMING_MOUSE_PC = 'resources/pc/images/step3/middle_img_lithium_mouse_pc.png'
const IMAGE_SMALL_PC = 'resources/pc/images/step4/small_img.png'
const IMAGE_CAR_PC = 'resources/pc/images/thanks/car_img.png'
const IMAGE_SAMPLE_PC = 'resources/pc/images/print/p_sample.gif'
const IMAGE_SAMPLE_SP = 'resources/sp/images/print/p_sample.gif'
const IMAGE_LOGO_PC = 'resources/pc/images/print/logo_header.jpg'
const IMAGE_LOGO_SP = 'resources/sp/images/print/logo_header.jpg'
const IMAGE_WASTE_PC = 'resources/pc/images/print/i_waste.gif'
const IMAGE_WASTE_SP = 'resources/sp/images/print/i_waste.gif'

const UNIT_TV = 0
const UNIT_FRIDGE = 0
const UNIT_WASHER_DRYER = 0
const UNIT_AC = 0
const UNIT_MICROWAVE = 0
const UNIT_VACUUM = 0
const UNIT_AP = 0
const UNIT_PRINTER = 0
const UNIT_PC = 0
const UNIT_CRT = 0
const UNIT_DESKTOP_MOUSE = 0
const UNIT_NOTE_MOUSE = 0
const UNIT_DISPLAY_MOUSE = 0
const UNIT_CRT_MOUSE = 0
const UNIT_LITHIUM_GAMING_MOUSE = 0
const QUANTITY_SMALL = 0

const MAXUNIT_TV = 4
const MAXUNIT_FRIDGE = 4
const MAXUNIT_WASHER_DRYER = 4
const MAXUNIT_AC = 4
const MAXUNIT_MICROWAVE = 4
const MAXUNIT_VACUUM = 4
const MAXUNIT_AP = 4
const MAXUNIT_PRINTER = 4
const MAXUNIT_PC = 4
const MAXUNIT_CRT = 4
const MAXUNIT_DESKTOP_MOUSE = 4
const MAXUNIT_NOTE_MOUSE = 4
const MAXUNIT_DISPLAY_MOUSE = 4
const MAXUNIT_CRT_MOUSE = 4
const MAXUNIT_LITHIUM_GAMING_MOUSE = 4
const MAXQUANTITY_SMALL = 10
const MAXQUANTITY_BIZ = 99

const ADDRESS_FORM_PATH = '/'
const LARGE_ITEMS_PATH = '/large'
const MEDIUM_ITEMS_PATH = '/medium'
const SMALL_ITEMS_PATH = '/small'
const SPECIFIC_DATETIME_PATH = '/datetime'
const CUSTOMER_INFORMATION_PATH = '/customer'
const CONFIRMATION_SCREEN_PATH = '/confirm'
const COMPLETE_PAGE_PATH = '/complete'
const DATA_ERASE_APPLICATION_FORM_PATH = '/DataEraseApplicationForm'
const DOWNLOAD_COMPLETE_PAGE_PATH = '/downloadComplete'
const REPORT_DOWNLOAD_PAGE_PATH = '/reportDownload'
const BASE_PATH = process.env.BASE_URL.slice(0, -1)

const LABELS_ADDITEM = ['3辺合計（縦横高）80~160cm', '重量10~30kg']
const UNIT_ADDITEM = 0
const MAXUNIT_ADDITEM = 4

const MEDIUM_BOX_COUNT = 0

const HIDE_NEXT = 'hide-next'
const SHOW_NEXT = 'show-next'
const HIDE_PREV = 'hide-prev'
const SHOW_PREV = 'show-prev'

const SPECIFIC_TIME_STR_ARRAY = ['ANYTIME', 'TIME1', 'TIME2', 'TIME3', 'TIME4']
const DAY_STR_ARRSY = [
    { name: '日', day: 'SUN' },
    { name: '月', day: 'MON' },
    { name: '火', day: 'TUE' },
    { name: '水', day: 'WED' },
    { name: '木', day: 'THU' },
    { name: '金', day: 'FRI' },
    { name: '土', day: 'SAT' }
]
const GENDER_LIST = [
    { value: '1', name: '男' },
    { value: '2', name: '女' },
    { value: '0', name: 'その他' }
]

const BIRTHDAY_FIRST_YEAR = 1926

// 禁止文字集合
const DISALLOW_STRINGS = ['￥', '¥'];

// コードマスタ - 料金区分 - 回収料金
const SMALL_APPLIANCES = '1'

// コードマスタ - データ消去サービス有
const DATA_ERASE_SERVICE = {'fee_kbn': "2", 'fee_category': "1"}

const BIRTHDAY_LAST_YEAR_ADJUST = 6

const CONTRACT_NAME = "契約書"
const CONTRACT_FILE_NAME = "業務委託契約書（YYYY年MM月DD日HH時mm分発行）.pdf"

const FONT_STYLE = "@font-face {\
                      font-family: 'Meiryo UI';\
                      font-style: normal;\
                      font-weight: 400;\
                      src: url('/usr/share/fonts/truetype/meiryo.ttc') format('truetype');\
                    }\
                    @font-face {\
                        font-family: 'Meiryo UI';\
                        font-weight: bold;\
                        src: url('/usr/share/fonts/truetype/meiryob.ttc') format('truetype');\
                    }"

export default {
    GET_POSTALCODES_URL,
    GET_SERVICE_URL,
    GET_FEE_URL,
    CONF_APP_URL,
    GET_MAKER_SIZE_URL,
    GET_SETTINGS_URL,
    GET_CODE_URL,
    CREATE_CONTRACT_URL,
    DOWNLOAD_CONTRACT_URL,
    GET_APP_INFO_URL,

    CYUKEIRYO_KBN,
    LARGEDELIVERY_KB,
    VALID_FLG,
    MAIL_OSR_SELECTIVE_DISPLAY,

    CODE_TV,
    CODE_FRIDGE,
    CODE_WASHER_DRYER,
    CODE_AC,
    CODE_MICROWAVE,
    CODE_VACUUM,
    CODE_AP,
    CODE_PRINTER,
    CODE_PC,
    CODE_CRT,
    CODE_SMALL,
    CODE_MEDIUM_OTHER,
    CODE_DESKTOP_MOUSE,
    CODE_NOTE_MOUSE,
    CODE_DISPLAY_MOUSE,
    CODE_CRT_MOUSE,
    CODE_LITHIUM_GAMING_MOUSE,

    NAME_TV,
    NAME_FRIDGE,
    NAME_WASHER_DRYER,
    NAME_AC,
    NAME_MICROWAVE,
    NAME_VACUUM,
    NAME_AP,
    NAME_PRINTER,
    NAME_PC,
    NAME_CRT,
    NAME_SMALL,
    NAME_DESKTOP_MOUSE,
    NAME_NOTE_MOUSE,
    NAME_DISPLAY_MOUSE,
    NAME_CRT_MOUSE,
    NAME_LITHIUM_GAMING_MOUSE,

    UNIT_TV,
    UNIT_FRIDGE,
    UNIT_WASHER_DRYER,
    UNIT_AC,
    UNIT_MICROWAVE,
    UNIT_VACUUM,
    UNIT_AP,
    UNIT_PRINTER,
    UNIT_PC,
    UNIT_CRT,
    QUANTITY_SMALL,
    UNIT_DESKTOP_MOUSE,
    UNIT_NOTE_MOUSE,
    UNIT_DISPLAY_MOUSE,
    UNIT_CRT_MOUSE,
    UNIT_LITHIUM_GAMING_MOUSE,

    MAXUNIT_TV,
    MAXUNIT_FRIDGE,
    MAXUNIT_WASHER_DRYER,
    MAXUNIT_AC,
    MAXUNIT_MICROWAVE,
    MAXUNIT_VACUUM,
    MAXUNIT_AP,
    MAXUNIT_PRINTER,
    MAXUNIT_PC,
    MAXUNIT_CRT,
    MAXQUANTITY_SMALL,
    MAXUNIT_DESKTOP_MOUSE,
    MAXUNIT_NOTE_MOUSE,
    MAXUNIT_DISPLAY_MOUSE,
    MAXUNIT_CRT_MOUSE,
    MAXUNIT_LITHIUM_GAMING_MOUSE,
    MAXQUANTITY_BIZ,

    BASE_PATH,
    ADDRESS_FORM_PATH,
    LARGE_ITEMS_PATH,
    MEDIUM_ITEMS_PATH,
    SMALL_ITEMS_PATH,
    SPECIFIC_DATETIME_PATH,
    CUSTOMER_INFORMATION_PATH,
    CONFIRMATION_SCREEN_PATH,
    COMPLETE_PAGE_PATH,
    DATA_ERASE_APPLICATION_FORM_PATH,
    DOWNLOAD_COMPLETE_PAGE_PATH,
    REPORT_DOWNLOAD_PAGE_PATH,

    LABELS_ADDITEM,
    UNIT_ADDITEM,
    MAXUNIT_ADDITEM,
    MEDIUM_BOX_COUNT,
    SPECIFIC_TIME_STR_ARRAY,
    DAY_STR_ARRSY,
    GENDER_LIST,

    BIRTHDAY_FIRST_YEAR,

    HIDE_NEXT,
    HIDE_PREV,
    SHOW_NEXT,
    SHOW_PREV,

    IMAGE_TV,
    IMAGE_FRIDGE,
    IMAGE_WASHER_DRYER,
    IMAGE_AC,
    IMAGE_MICROWAVE,
    IMAGE_VACUUM,
    IMAGE_AP,
    IMAGE_PRINTER,
    IMAGE_PC,
    IMAGE_CRT,
    IMAGE_SMALL,
    IMAGE_CAR,
    IMAGE_DESKTOP_MOUSE,
    IMAGE_NOTE_MOUSE,
    IMAGE_DISPLAY_MOUSE,
    IMAGE_CRT_MOUSE,
    IMAGE_LITHIUM_GAMING_MOUSE,
    IMAGE_TV_PC,
    IMAGE_FRIDGE_PC,
    IMAGE_WASHER_DRYER_PC,
    IMAGE_AC_PC,
    IMAGE_MICROWAVE_PC,
    IMAGE_VACUUM_PC,
    IMAGE_AP_PC,
    IMAGE_PRINTER_PC,
    IMAGE_PC_PC,
    IMAGE_CRT_PC,
    IMAGE_DESKTOP_MOUSE_PC,
    IMAGE_NOTE_MOUSE_PC,
    IMAGE_DISPLAY_MOUSE_PC,
    IMAGE_CRT_MOUSE_PC,
    IMAGE_LITHIUM_GAMING_MOUSE_PC,
    IMAGE_SMALL_PC,
    IMAGE_CAR_PC,
    IMAGE_SAMPLE_PC,
    IMAGE_SAMPLE_SP,
    IMAGE_LOGO_PC,
    IMAGE_LOGO_SP,
    IMAGE_WASTE_PC,
    IMAGE_WASTE_SP,

    ID_TV,
    ID_FRIDGE,
    ID_WASHER_DRYER,
    ID_AC,
    ID_MICROWAVE,
    ID_VACUUM,
    ID_AP,
    ID_PRINTER,
    ID_PC,
    ID_CRT,
    ID_DESKTOP_MOUSE,
    ID_NOTE_MOUSE,
    ID_DISPLAY_MOUSE,
    ID_CRT_MOUSE,
    ID_LITHIUM_GAMING_MOUSE,

    DISALLOW_STRINGS,

    SMALL_APPLIANCES,

    NAME_MEDIUM_OTHER,

    DATA_ERASE_SERVICE,

    BIRTHDAY_LAST_YEAR_ADJUST,

    CONTRACT_NAME,
    CONTRACT_FILE_NAME,

    FONT_STYLE
}
